"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Popup = exports.Error = exports.MapWrapper = exports.Root = void 0;
const CardContent_1 = require("@mui/material/CardContent");
const Paper_1 = require("@mui/material/Paper");
const styles_1 = require("@mui/material/styles");
exports.Root = (0, styles_1.styled)("div")(({ theme }) => ({
    position: "relative",
    height: "100%",
    [`.${Paper_1.paperClasses.root}`]: {
        display: "flex",
        flexDirection: "column",
        maxHeight: "100%",
        [`.${CardContent_1.cardContentClasses.root}`]: {
            display: "flex",
            flex: 1,
            overflow: "hidden"
        }
    }
}));
exports.MapWrapper = (0, styles_1.styled)("div")(({ theme }) => ({
    backgroundColor: theme.colours.pearl,
    alignItems: "center",
    display: "flex",
    justifyContent: "center",
    height: "100%"
}));
exports.Error = (0, styles_1.styled)("pre")(({ theme }) => ({
    color: theme.colours.error400
}));
exports.Popup = (0, styles_1.styled)("div")({
    left: 0,
    margin: "0 auto",
    position: "absolute",
    right: 0,
    top: 0,
    height: "100%",
    maxWidth: "500px",
    padding: "32px 20px",
    pointerEvents: "none",
    paddingTop: "86px",
    "& > *": {
        pointerEvents: "all"
    }
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3R5bGVzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2dvb2dsZS1tYXAvc3R5bGVzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFBLDJEQUErRDtBQUMvRCwrQ0FBbUQ7QUFDbkQsaURBQThDO0FBRWpDLFFBQUEsSUFBSSxHQUFHLElBQUEsZUFBTSxFQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsRUFBRSxLQUFLLEVBQUUsRUFBRSxFQUFFLENBQUMsQ0FBQztJQUNoRCxRQUFRLEVBQUUsVUFBVTtJQUNwQixNQUFNLEVBQUUsTUFBTTtJQUNkLENBQUMsSUFBSSxvQkFBWSxDQUFDLElBQUksRUFBRSxDQUFDLEVBQUU7UUFDekIsT0FBTyxFQUFFLE1BQU07UUFDZixhQUFhLEVBQUUsUUFBUTtRQUN2QixTQUFTLEVBQUUsTUFBTTtRQUNqQixDQUFDLElBQUksZ0NBQWtCLENBQUMsSUFBSSxFQUFFLENBQUMsRUFBRTtZQUMvQixPQUFPLEVBQUUsTUFBTTtZQUNmLElBQUksRUFBRSxDQUFDO1lBQ1AsUUFBUSxFQUFFLFFBQVE7U0FDbkI7S0FDRjtDQUNGLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxVQUFVLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ3RELGVBQWUsRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLEtBQUs7SUFDcEMsVUFBVSxFQUFFLFFBQVE7SUFDcEIsT0FBTyxFQUFFLE1BQU07SUFDZixjQUFjLEVBQUUsUUFBUTtJQUN4QixNQUFNLEVBQUUsTUFBTTtDQUNmLENBQUMsQ0FBQyxDQUFDO0FBRVMsUUFBQSxLQUFLLEdBQUcsSUFBQSxlQUFNLEVBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxFQUFFLEtBQUssRUFBRSxFQUFFLEVBQUUsQ0FBQyxDQUFDO0lBQ2pELEtBQUssRUFBRSxLQUFLLENBQUMsT0FBTyxDQUFDLFFBQVE7Q0FDOUIsQ0FBQyxDQUFDLENBQUM7QUFFUyxRQUFBLEtBQUssR0FBRyxJQUFBLGVBQU0sRUFBQyxLQUFLLENBQUMsQ0FBQztJQUNqQyxJQUFJLEVBQUUsQ0FBQztJQUNQLE1BQU0sRUFBRSxRQUFRO0lBQ2hCLFFBQVEsRUFBRSxVQUFVO0lBQ3BCLEtBQUssRUFBRSxDQUFDO0lBQ1IsR0FBRyxFQUFFLENBQUM7SUFDTixNQUFNLEVBQUUsTUFBTTtJQUNkLFFBQVEsRUFBRSxPQUFPO0lBQ2pCLE9BQU8sRUFBRSxXQUFXO0lBQ3BCLGFBQWEsRUFBRSxNQUFNO0lBQ3JCLFVBQVUsRUFBRSxNQUFNO0lBQ2xCLE9BQU8sRUFBRTtRQUNQLGFBQWEsRUFBRSxLQUFLO0tBQ3JCO0NBQ0YsQ0FBQyxDQUFDIn0=